import RsaGestionePresenze from "../";

const routes = [{ name: "RsaGestionePresenzeList", path: "/rsagestionepresenzelist", component: RsaGestionePresenze.RsaGestionePresenzeListPage, meta: { title: "R.S.A. - Gestione Presenze" } }];
export default routes;
